<template>
    <div class="animated fadeIn">
        <div v-if="loading" class="loading-container">
            <b-row class="justify-content-center">
                <b-col cols="12" class="text-center">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <div v-else>
        <component-header
            title="User Management"
            @search-query="onSearchQuery"
            :isLoading="loading"
            @reload-data="reloadData"
            :hasReload="true"
            @create-press="createUserRoute"
            :hasback="true"
            @back-press="$router.push('./dashboard')"
        />
        <b-card class="card-wrap" border-variant="info">
            <div class="table-responsive-wrapper">
                <b-table
                    class="table-border-radius professional-stacked-table"
                    :dark="dark"
                    :hover="hover"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    :fixed="fixed"
                    responsive
                    :items="tenantSubAdmins"
                    :fields="tenantColumns"
                    :current-page="searchQuery ? currentPage : 0"
                    :per-page="searchQuery ? perPage : 0"
                    :filter="searchQuery"
                    :filter-function="customFilter"
                    @filtered="onFiltered"
                    thead-class="header"
                    show-empty
                    :busy="loading"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                >
                    <template slot="cell(status)" slot-scope="data">
                        <div class="table-row">
                            {{ data.item.status || "ACTIVE" }}
                        </div>
                    </template>
                    <template slot="cell(action)" slot-scope="data">
                        <div class="inline_btnTable">
                            <ActionButtonGroup
                                showView
                                showEdit
                                showDelete
                                @view="viewUser(data.item)"
                                @edit="editUser(data.item)"
                                @delete="deleteUser(data.item)"
                            />
                        </div>
                    </template>
                </b-table>
            </div>
            <div class="pagination-wrapper">
                <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="
                        searchQuery ? filteredCount : userListMeta.total
                    "
                    aria-controls="my-table"
                    prev-text="Prev"
                    next-text="Next"
                    hide-goto-end-buttons
                    @change="getTenantData"
                    class="justify-content-center justify-content-md-end"
                ></b-pagination>
            </div>
        </b-card>
    </div>
    </div>
</template>
<script>
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";
export default {
    name: "userlist",
    components: { ComponentHeader, AtomSpinner, ActionButtonGroup },
    data() {
        return {
            filterCount: 0,
            loading: false,
            perPage: 10,
            currentPage: 1,
            searchQuery: "",
            filteredCount: 0,
            customFilter(row, filter) {
                if (!filter || !String(filter).trim()) return true;
                const term = String(filter).trim().toLowerCase();
                const fields = [
                    row.fullName,
                    row.city,
                    row.email,
                    row.phone,
                    row.meta && row.meta.kycStatus,
                    row.status,
                    row.category,
                ];
                return fields.some(
                    (val) => val && String(val).toLowerCase().includes(term),
                );
            },
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            context: "Add",
            sortBy: "createdAt",
            sortDesc: true,
            tenantColumns: [
                {
                    key: "fullName",
                    label: "Name",
                    sortable: true,
                },
                {
                    key: "city",
                },
                {
                    key: "email",
                },
                {
                    key: "phone",
                },
                {
                    key: "meta.kycStatus",
                    label: "Kyc Status",
                },
                {
                    key: "status",
                    label: "User Status",
                },
                {
                    key: "category",
                },
                {
                    key: "action",
                    thStyle: { minWidth: "150px" },
                },
            ],
            status: "ACTIVE",
        };
    },
    computed: {
        ...mapState({ userListMeta: (state) => state.tenant.userListMeta }),
        tenantSubAdmins() {
            let data = this.$store.getters["tenant/GetTenantSubAdminList"];
            let tenantList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    let arrayObj = {
                        _id: obj._id,
                        city: obj?.address?.city,
                        state: obj?.address?.state,
                        country: obj?.address?.country,
                        zip: obj?.address?.zip,
                        userName: obj?.authentication?.userName,
                        email: obj?.authentication?.email,
                        phone: obj?.authentication?.phone,
                        fullName: `${obj.name.first} ${obj.name.last}`,
                        password: "",
                        status: obj?.status,
                        orgAccessLevel:
                            obj?.authorization?.orgAccess?.orgAccessLevel,
                        category: obj?.authorization?.category,
                        value: obj?.experience ? obj?.experience?.value : "",
                        uom: obj?.experience ? obj?.experience?.uom : "",
                        createdAt: obj?.createdAt,
                        ...obj,
                    };
                    tenantList.push(arrayObj);
                });
                return tenantList;
            } else {
                this.loading = false;
                return [];
            }
        },
    },
    methods: {
        onSearchQuery(val) {
            this.searchQuery = val;
            this.currentPage = 1;
            if (val) {
                this.fetchAllUsers();
            } else {
                this.getSubtanentList();
            }
        },
        onFiltered(filteredItems) {
            this.filteredCount = filteredItems.length;
            this.currentPage = 1;
        },
        reloadData() {
            this.searchQuery = "";
            this.filteredCount = 0;
            this.currentPage = 1;
            this.getSubtanentList();
        },
        async getTenantData(e) {
            this.currentPage = e;
            if (!this.searchQuery) {
                await this.getSubtanentList();
            }
        },
        createUserRoute() {
            this.$router.push({ name: "CreateUser" });
        },
        viewUser(data) {
            if (this.$router.history.current.name === "partner-user") {
                this.$router.push({
                    name: "ViewUser",
                    params: { userId: data._id, userData: data },
                });
            } else {
                this.$router.push({
                    name: "View User",
                    params: { userId: data._id, userData: data },
                });
            }
        },
        editUser(data) {
            if (data.status == "PENDING") {
                this.$swal({
                    title: "Your Approval is Pending",
                    text: "Get your Approval Done From Distributor",
                    type: "warning",
                });
            } else {
                if (this.$router.history.current.name === "partner-user") {
                    this.$router.push({
                        name: "Edit User",
                        params: { id: data._id, userData: data },
                    });
                } else {
                    this.$router.push({
                        name: "EditUser",
                        params: { id: data._id, userData: data },
                    });
                }
            }
        },
        async deleteUser(data) {
            await this.$swal({
                title: "Are you sure?",
                text: "You can't revert this action!!",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
                cancelButtonColor: "#3085d6",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.isLoading = true;
                    this.$store
                        .dispatch("tenant/deleteUser", data._id)
                        .then((result) => {
                            this.$toasted.success("User Deleted Successfully");
                            this.getSubtanentList();
                        });
                    this.isLoading = false;
                }
            });
        },
        async fetchAllUsers() {
            this.loading = true;
            const payload = { limit: 10000, page: 1 };
            if (this.$route.params.id) {
                payload.parent = this.$route.params.id;
            }
            if (this.searchQuery && this.searchQuery.trim()) {
                payload.search = this.searchQuery.trim();
            }
            await this.$store
                .dispatch("tenant/fetchTenantSubAdminList", payload)
                .then(() => {
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        async getSubtanentList() {
            this.loading = true;
            const payload = { limit: this.perPage, page: this.currentPage };
            if (this.$route.params.id) {
                payload.parent = this.$route.params.id;
            }
            await this.$store
                .dispatch("tenant/fetchTenantSubAdminList", payload)
                .then((data) => {
                    if (data.message) {
                        this.$toasted.error(data.message);
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
    },
    async mounted() {
        if (this.partnerAllData == null && this.$route.params.id) {
            await this.$store.dispatch(
                "partner/fetchPartnerById",
                this.$route.params.id,
            );
        } else if (this.$currentUserData.role == "Partner") {
            const payload = { limit: this.perPage, page: this.currentPage };
            payload.parent = this.$currentUserData._id;
            await this.$store.dispatch(
                "tenant/fetchTenantSubAdminList",
                payload,
            );
        } else {
            await this.getSubtanentList();
        }
    },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important

.text-center
  text-align: center

.form-div label
  margin-top: 8px


.button-circle
  width: 34px
  height: 34px
  border-radius: 50% !important
  padding: 0 !important
  margin: 0
  display: inline-flex
  align-items: center
  justify-content: center
  font-size: 14px

  i
    margin: 0
    font-size: 14px
    line-height: 1

.loading-container
  min-height: 200px
  display: flex
  align-items: center
  justify-content: center

.table-border-radius
  border-radius: 12px

.btn-orange
  background: #fe7b08
  border: #fe7b08

.pagination-wrapper
  margin-top: 1rem

@media (max-width: 576px)
  .inline_btnTable
    flex-direction: row
    flex-wrap: nowrap
    gap: 4px

  .pagination-wrapper
    text-align: center
</style>
<style scoped>
/* Default (all screens) */
.inline_btnTable {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
    white-space: nowrap;
}

/* Mobile fix */
@media (max-width: 576px) {
    .inline_btnTable {
        flex-direction: row;
        flex-wrap: nowrap;
        gap: 4px;
    }

    .inline_btnTable .button-circle {
        margin: 0 !important;
        width: 34px;
        height: 34px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
